export default () =>
  import(/* webpackChunkName: 'coffee/website' */ './Website');
